"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Banner_1 = __importDefault(require("components/Banner"));
const Layout_1 = require("components/base/Layout");
const VideoPreview_1 = __importDefault(require("components/content/VideoPreview"));
const DynamicFlash_1 = __importDefault(require("components/DynamicFlash"));
const IndefinitePaginatedList_1 = __importDefault(require("components/IndefinitePaginatedList"));
const RenderToRoot_1 = __importDefault(require("components/RenderToRoot"));
const MainLayout_1 = __importDefault(require("layouts/MainLayout"));
const VideosPage = ({ loginCallback = '/', videos, lastKey }) => {
    const [items, setItems] = (0, react_1.useState)(videos);
    const [currentLastKey, setLastKey] = (0, react_1.useState)(lastKey);
    return (react_1.default.createElement(MainLayout_1.default, { loginCallback: loginCallback },
        react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "2", className: "my-2" },
            react_1.default.createElement(Banner_1.default, null),
            react_1.default.createElement(DynamicFlash_1.default, null),
            react_1.default.createElement(IndefinitePaginatedList_1.default, { items: items, setItems: setItems, lastKey: currentLastKey, setLastKey: setLastKey, pageSize: 24, header: "Videos", fetchMoreRoute: `/content/getmorevideos`, renderItem: (item) => react_1.default.createElement(VideoPreview_1.default, { video: item }), noneMessage: "No videos found.", xs: 6, lg: 4, xl: 3, xxl: 2, inCard: true }))));
};
exports.default = (0, RenderToRoot_1.default)(VideosPage);
